import type { ReactNode } from "react";
import {
  IconAdjustments,
  IconBell,
  IconBuildingChurch,
  IconCamera,
  IconFileText,
  IconHome,
  IconLiveView,
  IconMovie,
  IconNetwork,
  IconServer,
  IconShield,
  IconUsers,
  IconWorld,
  IconBrandYoutube,
  IconQrcode,
  IconArticle,
  IconLayoutDashboard,
  IconPhoto,
  IconSitemap,
  IconHistory,
  IconCross,
  IconCrop,
} from "@tabler/icons-react";
import type { UserRole } from "../features/auth/types";

export type NavigationItem = {
  label: string;
  to: string;
  icon: ReactNode;
  section?: string;
  children?: NavigationItem[];
};

const iconProps = { size: 20, stroke: 1.7, "aria-hidden": true } as const;

export const superadminNavigation: NavigationItem[] = [
  {
    label: "Dashboard",
    to: "/superadmin",
    icon: <IconHome {...iconProps} />,
    section: "Przegląd",
  },
  {
    label: "Parafie",
    to: "/superadmin/parishes",
    icon: <IconBuildingChurch {...iconProps} />,
    section: "Zarządzanie",
  },
  {
    label: "Administratorzy",
    to: "/superadmin/users",
    icon: <IconUsers {...iconProps} />,
  },
  {
    label: "Kamery i źródła",
    to: "/superadmin/sources",
    icon: <IconCamera {...iconProps} />,
    section: "Transmisje",
  },
  {
    label: "Kanały publikacji",
    to: "/superadmin/channels",
    icon: <IconNetwork {...iconProps} />,
  },
  {
    label: "Komunikat startowy",
    to: "/superadmin/application/startup",
    icon: <IconAdjustments {...iconProps} />,
    section: "Aplikacje",
  },
  {
    label: "Dokumenty",
    to: "/superadmin/application/legal",
    icon: <IconFileText {...iconProps} />,
  },
  {
    label: "Materiał przed LIVE",
    to: "/superadmin/application/pre-transmission",
    icon: <IconMovie {...iconProps} />,
  },
  {
    label: "Serwery",
    to: "/superadmin/monitoring/servers",
    icon: <IconServer {...iconProps} />,
    section: "Monitoring",
  },
  {
    label: "MediaMTX",
    to: "/superadmin/monitoring/mediamtx",
    icon: <IconLiveView {...iconProps} />,
  },
];

export const adminNavigation: NavigationItem[] = [
  {
    label: "Dashboard",
    to: "/admin",
    icon: <IconHome {...iconProps} />,
    section: "Przegląd",
  },
  {
    label: "Strona WWW",
    to: "/admin/website",
    icon: <IconWorld {...iconProps} />,
    section: "Parafia",
    children: [
      {
        label: "Kreator strony WWW",
        to: "/admin/website",
        icon: <IconLayoutDashboard {...iconProps} />,
      },
      {
        label: "Dotychczasowe ustawienia",
        to: "/admin/website/advanced",
        icon: <IconAdjustments {...iconProps} />,
      },
      {
        label: "Wygląd i publikacja",
        to: "/admin/website/appearance",
        icon: <IconAdjustments {...iconProps} />,
      },
      {
        label: "Dane parafii",
        to: "/admin/website/profile",
        icon: <IconBuildingChurch {...iconProps} />,
      },
      {
        label: "Media",
        to: "/admin/website/media",
        icon: <IconPhoto {...iconProps} />,
      },
      {
        label: "Zdjęcia aplikacji",
        to: "/admin/website/images",
        icon: <IconCrop {...iconProps} />,
      },
      {
        label: "Strony",
        to: "/admin/website/pages",
        icon: <IconFileText {...iconProps} />,
      },
      {
        label: "Wpisy",
        to: "/admin/website/posts",
        icon: <IconArticle {...iconProps} />,
      },
      {
        label: "Elementy modułów",
        to: "/admin/website/records",
        icon: <IconSitemap {...iconProps} />,
      },
      {
        label: "Galerie",
        to: "/admin/website/galleries",
        icon: <IconPhoto {...iconProps} />,
      },
      {
        label: "Moduły i menu",
        to: "/admin/website/modules",
        icon: <IconSitemap {...iconProps} />,
      },
      {
        label: "Dodatkowe linki",
        to: "/admin/website/menu",
        icon: <IconNetwork {...iconProps} />,
      },
      {
        label: "Cmentarz",
        to: "/admin/website/cemetery",
        icon: <IconCross {...iconProps} />,
      },
      {
        label: "Historia wersji",
        to: "/admin/website/revisions",
        icon: <IconHistory {...iconProps} />,
      },
    ],
  },
  {
    label: "Kościoły i godziny",
    to: "/admin/churches",
    icon: <IconBuildingChurch {...iconProps} />,
  },
  {
    label: "Wsparcie i QR",
    to: "/admin/support",
    icon: <IconQrcode {...iconProps} />,
  },
  {
    label: "LIVE InfoParafia",
    to: "/admin/live",
    icon: <IconCamera {...iconProps} />,
    section: "Transmisje",
  },
  {
    label: "LIVE YouTube",
    to: "/admin/youtube",
    icon: <IconBrandYoutube {...iconProps} />,
  },
  {
    label: "Powiadomienia",
    to: "/admin/notifications",
    icon: <IconBell {...iconProps} />,
    section: "Komunikacja",
  },
  {
    label: "Administratorzy",
    to: "/admin/users",
    icon: <IconShield {...iconProps} />,
    section: "Dostęp",
  },
];

export function navigationForRole(role: UserRole): NavigationItem[] {
  return role === "SUPERADMIN" ? superadminNavigation : adminNavigation;
}
